import React from "react";
import { colors } from "../../styles/colors";

const buildTwoToneParts = (title, highlightWords) => {
  if (!title) {
    return { primary: "", accent: "" };
  }

  const trimmed = title.trim();
  if (!trimmed.includes(" ")) {
    return { primary: trimmed, accent: "" };
  }

  const words = trimmed.split(/\s+/);
  const safeHighlightCount = Math.max(1, Math.min(highlightWords, words.length - 1));
  const accentWords = words.slice(-safeHighlightCount);
  const primaryWords = words.slice(0, words.length - safeHighlightCount);

  return {
    primary: primaryWords.join(" "),
    accent: accentWords.join(" "),
  };
};

const HeroHeading = ({
  primary,
  accent,
  title,
  highlightWords = 2,
  className = "",
  stacked = false,
  textAlign = "center",
}) => {
  let primaryText = primary;
  let accentText = accent;

  if (!primaryText && !accentText) {
    const parts = buildTwoToneParts(title, highlightWords);
    primaryText = parts.primary;
    accentText = parts.accent;
  }

  if (!primaryText && accentText) {
    primaryText = accentText;
    accentText = "";
  }

  return (
    <h1
      className={`font-bold leading-tight text-${textAlign} ${className}`.trim()}
      style={{ color: colors.text.primary }}
    >
      {primaryText}
      {accentText && (
        <>
          {stacked ? <br /> : " "}
          <span style={{ color: colors.accent.primary }}>{accentText}</span>
        </>
      )}
    </h1>
  );
};

export default HeroHeading;
